import * as React       from 'react'
import Routing          from '../../routing/managementRoutes'

export default (props)=> <Routing />
